
// 현재 언어를 가져오는 함수
export const getCurrentLang = (i18n) => {
  return i18n?.language || window.localStorage.i18nextLng || 'ko';
};

// i18n을 넘기고 각 언어별 값을 넘기면 현재 언어에 맞는 값을 리턴
export const resolveI18n = (data) => {
  const { i18n = null, ko = null , en = null, vi = null } = data;
  if (!i18n || !ko || !en || !vi) {
    throw new Error("Missing translation data");
  }

  const lang = getCurrentLang(i18n);

  return lang === 'ko' ? ko : lang === 'en' ? en : vi;
}